import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import {QuestionItem} from "../../common/webapicall";
import AutoFillDictateSelect from "./questionnaire.autofill.dictate.dropdown";
import {TaxonomySelect} from "./types/questionnaire.autofill.dictate.taxonomy.select";
import {Taxonomy} from "./types/questionnaire.autofill.dictate.taxonomy";

interface QuestionnaireAutoFillDictatePanelProps {
	appStore?: AppStore;
	questionList: QuestionItem[];
	onSubmit: () => void;
}

interface QuestionnaireAutoFillDictatePanelState {
	taxonomies: Taxonomy[];
	selectedOptions: {
		[key: string]: number;
	};
}

@useAppStore()
export default class QuestionnaireAutoFillDictatePanel extends React.Component<QuestionnaireAutoFillDictatePanelProps, QuestionnaireAutoFillDictatePanelState> {
	private questionnaireStore = this.props.appStore.questionnaireStore;
	constructor(props) {
		super(props);
		this.state = {
			taxonomies: [],
			selectedOptions: {},
		};
	}

	componentDidMount() {
		this.countTaxonomiesAndQuestions();
	}

	private countTaxonomiesAndQuestions() {
		const taxonomies: Taxonomy[] = [];
		this.props.questionList.forEach((question: QuestionItem) => {
			const taxonomyIndex = taxonomies.findIndex((taxonomy) => taxonomy.taxonomyName === question.debugDetails.taxonomyName);
			if (taxonomyIndex !== -1) {
				taxonomies[taxonomyIndex].numberOfQuestions++;
			} else {
				taxonomies.push({taxonomyName: question.debugDetails.taxonomyName, numberOfQuestions: 1});
			}
		});
		taxonomies.sort((a, b) => (a.taxonomyName > b.taxonomyName ? 1 : b.taxonomyName > a.taxonomyName ? -1 : 0));
		this.setState({
			taxonomies: taxonomies,
		});
	}

	private dictateQuestionnaire = () => {		
		const currentSelectedOptions = {...this.state.selectedOptions};
		this.props.questionList.forEach((question: QuestionItem) => {
			if (currentSelectedOptions[question.debugDetails.taxonomyName] && currentSelectedOptions[question.debugDetails.taxonomyName] > 0) {
				this.props.appStore.questionnaireStore.handleAnswerChange(question.questionId, question.debugDetails.correctAnswer);
				currentSelectedOptions[question.debugDetails.taxonomyName]--;
			} else {
				this.props.appStore.questionnaireStore.handleAnswerChange(question.questionId, !question.debugDetails.correctAnswer);
			}
		});
	};

	private dictateAndSubmitQuestionnaire = () => {
		this.dictateQuestionnaire();
		this.props.onSubmit();
	};

	private storeSelectedOption = (selectedOption: TaxonomySelect) => {
		this.setState((previousState) => ({
			selectedOptions: {
				...previousState.selectedOptions,
				[selectedOption.taxonomyName]: selectedOption.numberOfCorrectAnswers,
			},
		}));
	};

	render() {
		if (!this?.state?.taxonomies) {
			return null;
		}
		return (
			<div className="cih-dictate-results">
				<h3 className="cih-h3">Dictate results</h3>
				<p className="cih-para">Select the number of correct answers for each dimension below</p>
				<div className="cih-dictate-dd-group">
					{this.state.taxonomies.map((taxonomy) => (
						<AutoFillDictateSelect key={taxonomy.taxonomyName} title={taxonomy.taxonomyName} numberOfQuestions={taxonomy.numberOfQuestions} onChange={this.storeSelectedOption} />
					))}
				</div>
				<div className="cih-flex cih-btn-group">
					<button className="cih-btn" onClick={this.dictateQuestionnaire}>
						Fill sheet
					</button>
					<button className="cih-btn" disabled={this.questionnaireStore.isQuestionnaireSubmitLoading} onClick={this.dictateAndSubmitQuestionnaire}>
						Specify and submit
					</button>
				</div>
			</div>
		);
	}
}
